export default "__VITE_ASSET__CXyu83Ld__"